
import { defineComponent } from 'vue';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons-vue';

export default defineComponent({
  name: 'FieldBig',
  props: {
    label: {
      type: String,
      default: () => undefined,
    },
    value: {
      type: [Number, String],
      default: () => undefined,
    },
    value1: {
      type: Boolean,
      default: () => undefined,
    },
  },
  components: {
    ArrowUpOutlined,
    ArrowDownOutlined,
  },
});
